import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { FaUserShield, FaCheckCircle } from "react-icons/fa";
import { ThemeContext } from "../../contexts/themeContext";
import UserSession from "../../utils/userSessionClass";
import "../../assets/styles/card-blacklist.scss";

export default function Profile() {
  const { t } = useTranslation();
  const { themedColor } = useContext(ThemeContext);

  // Dynamically extract logged-in user profile details
  const userSession = new UserSession();
  const sessionVals = userSession.getSessionValues();

  let loginData = {};
  try {
    const credsStr = localStorage.getItem("login_credentials");
    if (credsStr) {
      const parsed = JSON.parse(credsStr);
      loginData = parsed.data || {};
    }
  } catch (_) {}

  const activeUser = {
    name:
      loginData.name ||
      sessionVals.employeeName ||
      (sessionVals.username
        ? sessionVals.username.split("@")[0]
        : "Super Admin"),
    email:
      loginData.userName ||
      sessionVals.username ||
      localStorage.getItem("sType") ||
      "superadmin@forthcode.com",
    userId: loginData.userId || sessionVals.user_id || "N/A",
    role: loginData.role || "Super Admin",
    provider: "Forthcode SSO",
    loginTime: sessionVals.login_date
      ? `${sessionVals.login_date} (${sessionVals.login_time || ""})`
      : "Active Session",
  };

  const isDark = themedColor?.sidebar === "#181818";

  return (
    <div className={`blacklist-container ${isDark ? "dark" : "light"}`}>
      {/* Header Row */}
      <div className="blacklist-header-row">
        <div className="title-area">
          <h1>{t("pages.controlPanelMenuSub.superAdminProfile")}</h1>
          <p>Security profile and identity access management panel</p>
        </div>
      </div>

      <div className="profile-grid">
        {/* Identity Info Panel */}
        <div className="profile-identity-card">
          <div className="identity-header">
            <div className="identity-avatar">
              <FaUserShield />
            </div>
            <div>
              <h3>{activeUser.name}</h3>
              <span className="badge-reason">
                Authenticated via {activeUser.provider}
              </span>
            </div>
          </div>

          <hr className="profile-divider" />

          <div className="identity-details">
            <div className="detail-row">
              <span className="detail-label">Identity Email</span>
              <strong className="detail-value">{activeUser.email}</strong>
            </div>
            <div className="detail-row">
              <span className="detail-label">User ID</span>
              <strong className="detail-value">{activeUser.userId}</strong>
            </div>
            <div className="detail-row">
              <span className="detail-label">Role / Authorization Level</span>
              <strong className="detail-value text-danger">
                {activeUser.role}
              </strong>
            </div>
            <div className="detail-row">
              <span className="detail-label">Identity Provider (IDP)</span>
              <strong className="detail-value">{activeUser.provider}</strong>
            </div>
            <div className="detail-row">
              <span className="detail-label">Last Login Session</span>
              <strong className="detail-value">{activeUser.loginTime}</strong>
            </div>
            <div className="detail-row">
              <span className="detail-label">Authentication Status</span>
              <span className="text-success font-weight-bold">
                <FaCheckCircle /> Active & Secured
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
